<template>
  <div class="k_main">
    <searchC></searchC>
    <div class="content" style="width: 1250px">
      <div class="topadcs">
        <img
          :src="kimg.tp"
          v-if="kimg.tp"
          title="世界知名焊接设备首选供应商"
          alt="世界知名焊接设备首选供应商"
        />
      </div>
      <div class="rightl" style="width: 1025px">
        <div class="righttop"></div>
        <div class="pro_main">
          <div id="printableview">
            <div class="pro_curmbs">
              <span>当前位置:</span>
              首页 &raquo; 产品中心 &raquo; {{ list.sval }}
            </div>
            <div class="pleft">
              <div class="mainbox">
                <div class="maincont">
                  <div class="prodetailsinfo">
                    <div class="proviewbox">
                      <div class="probigshow">
                        <img
                          :src="list.img"
                          v-if="list.img"
                          style="width: 340px; height: 340px"
                        />
                      </div>
                    </div>
                    <div class="clear"></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="pright">
              <div class="propar">
                <h4 class="corange">{{ list.name }}</h4>
                <div class="cpt pd_columns">
                  产品分类：
                  <span>{{ list.sval }}</span>
                </div>
                <div class="cpc pd_attr"></div>
                <div class="cps pd_short">{{ list.sx }}</div>
                <div class="pd_hotline">
                  <span>订购热线：</span>
                  <span class="font_hotline">18616336851</span>
                  <br />
                  <span style="color: #fff">订购热线：</span>
                  <span class="font_hotline">021-65056515</span>
                </div>
              </div>
              <!-- Baidu Button BEGIN -->
              <div
                id="bdshare"
                class="bdshare_t bds_tools_32 get-codes-bdshare"
              >
                <a class="bds_qzone"></a>
                <a class="bds_tsina"></a>
                <a class="bds_tqq"></a>
                <a class="bds_renren"></a>
                <a class="bds_t163"></a>
                <span class="bds_more"></span>
                <a class="shareCount"></a>
              </div>
              <div class="clear"></div>
              <!-- Baidu Button END -->
              <div class="propar" style="text-align: center; padding-top: 20px">
                <div class="proparp">
                  <img
                    style="border: 0"
                    src="../../static/images/buynowsmalls.gif"
                    @click="tofooter"
                  />
                </div>
              </div>
            </div>
            <div class="clear"></div>

            <div class="clear"></div>
            <div class="cp">
              <div class="cptab">
                <a
                  href="javascript:void(0)"
                  onmouseover="switchProdTab(this)"
                  target_id="cptab_relevant"
                  class="cr"
                  >跟此产品相关的产品</a
                >
                <!--<a href="javascript:void(0)" onmouseover="switchProdTab(this)"
                target_id="divRelevantViewedCntr">浏览过此产品的人还浏览过</a>-->
                <div class="clear"></div>
              </div>
              <div id="cntrRelevantProd">
                <div id="cptab_relevant">
                  <dl v-for="item in plist" :key="item.id">
                    <router-link
                      :to="{ name: 'pinfo', params: { id: item.id, nid: 5 } }"
                    >
                      <dt>
                        <img :src="item.img" />
                      </dt>
                      <dd class="t1">{{ item.name }}</dd>
                    </router-link>
                  </dl>
                </div>
              </div>
              <div class="clear"></div>
            </div>
            <div class="fenlei">
              <div class="tits">
                <a
                  id="detail0"
                  class="cur"
                  onclick="switchExtendAttrTab('detail0',2)"
                >
                  <span>产品详情</span>
                </a>
                <div class="clear"></div>
              </div>
            </div>
            <div class="proinfo" style="margin-left: 0px">
              <div v-html="list.ms"></div>
              <br />
              <br />
              <!--<div class="clear"></div>-->
              <p style="text-align: left">
                <img
                  src="../../static/images/6355606052646267978494818.jpg"
                  title="售后服务.jpg"
                />
              </p>
              <p>1、整机保修壹年，终身维修；</p>
              <p>2、免费安装、调试和对操作、维修人员培训；</p>
              <p>3、免费提供升级软件；</p>
              <p>
                <span style="color: rgb(49, 133, 155)">
                  <strong>【验收方式】</strong>
                </span>
              </p>
              <p>1、在设备使用现场进行验收；</p>
              <p>2、齐套性（资料、备件）和产品外观验收；</p>
              <p>3、由供方派人进行设备安装、调试；</p>
              <p>4、设备各项功能演示；</p>
              <p>5、连续10小时拷机；</p>
              <p>6、供方对需方选定的工件进行打标，检测打标是否满足要求；</p>
              <p>7、测试有关技术指标；</p>
              <p>
                8、供方派人对需方操作、维护人员进行为期1个工作日的技术培训；
              </p>
              <p>9、设备经调试无故障后，供需双方代表签定验收报告。</p>
              <p>
                <span style="color: rgb(49, 133, 155)">
                  <strong>【培训】</strong>
                </span>
              </p>
              <p>1、供方派人到需方现场培训（安装调试完设备后实施）；</p>
              <p>2、培训人员：操作工，电器、机械维修人员，人数由需方自定；</p>
              <p>
                3、培训内容：设备的安装调试及标记机的原理、组成和计算机常用知识。计算机编程、电气控制原理及设备日常维护等，并进行实际操作。设备常见故障排除培训，进一步熟悉设备，答疑，最后对培训人员进行考核。
              </p>
              <p>
                <span style="color: rgb(49, 133, 155)">
                  <strong>【质量保证服务】</strong>
                </span>
              </p>
              <p>1、供方提供以下技术支持，指导需方进行安全正确使用、维护。</p>
              <p>&nbsp; （1）设备的使用说明书、应用软件备份；</p>
              <p>&nbsp; （2）产品合格证。</p>
              <p>
                2、保修期为12个月，时间从最终验收结果签署之日算起。保修期内免费维修，保修期外酌情收取维修费用。设备出现故障，反应时间为4小时，如有必要到现场，供方维修人员正常情况下在24小时内到达现场。
              </p>
              <p>
                &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                &nbsp; &nbsp;
                <img
                  title="琼琚焊机产品优势"
                  src="../../static/images/6354622124092825005196554.jpg"
                />
                <br />
              </p>
              <p style="text-align: center">
                <img
                  src="../../static/images/6354855032840277298850341.jpg"
                  style
                  title="威遥焊接点焊设备"
                />
              </p>
              <p style="text-align: center">
                <img
                  src="../../static/images/6354845601796390235861783.jpg"
                  style
                  title="威遥焊接点焊设备"
                />
              </p>
              <p style="text-align: left">
                <img
                  title="威遥焊接简介"
                  src="../../static/images/6354613683085012509517641.jpg"
                />
              </p>
              <p style="text-align: left; text-indent: 2em">
                <img
                  style="float: right"
                  title="联系方式"
                  src="../../static/images/6354622071003762501821105.jpg"
                />
              </p>

              <br />
              <p
                style="
                  line-height: 150%;
                  margin-top: 0pt;
                  margin-bottom: 0pt;
                  direction: ltr;
                  unicode-bidi: embed;
                  vertical-align: baseline;
                "
              >
                威遥焊接公司，创建于2012年，是国内智能化程控焊接系统领域为客户提供焊接自动化整体方案的供应商，同时为客户提供焊接整体工艺解决、现场焊接问题处理、帮助客户制定完善高效可靠的解决方案的服务商。主要产品为自动化管焊机、焊接专机、及各类焊接辅助设备。
              </p>
              <p
                style="
                  line-height: 150%;
                  margin-top: 0pt;
                  margin-bottom: 0pt;
                  direction: ltr;
                  unicode-bidi: embed;
                  vertical-align: baseline;
                "
              >
                <br />
              </p>
              <p
                style="
                  line-height: 150%;
                  margin-top: 0pt;
                  margin-bottom: 0pt;
                  direction: ltr;
                  unicode-bidi: embed;
                  vertical-align: baseline;
                "
              >
                威遥焊接团队，来自于从事国内外不同品牌自动焊接设备厂家的专业人员；经过慎重分析不同品牌产品的优势，学其所长，致力于产品操作简单化，焊接工艺精湛化，售后服务无忧化。
              </p>
              <p
                style="
                  line-height: 150%;
                  margin-top: 0pt;
                  margin-bottom: 0pt;
                  direction: ltr;
                  unicode-bidi: embed;
                  vertical-align: baseline;
                "
              >
                <br />
              </p>
              <p
                style="
                  line-height: 150%;
                  margin-top: 0pt;
                  margin-bottom: 0pt;
                  direction: ltr;
                  unicode-bidi: embed;
                  vertical-align: baseline;
                "
              >
                威遥团队理念，只有以客户为本，为客户创造价值的产品，才是真正意义上的产品。
                在三年时间里威遥团队在大量吸收采纳客户建议的基础上，不断完善产品，目前不论从操作性，焊接工艺，产品稳定性等方面都有优良的表现。
              </p>
              <p
                style="
                  line-height: 150%;
                  margin-top: 0pt;
                  margin-bottom: 0pt;
                  direction: ltr;
                  unicode-bidi: embed;
                  vertical-align: baseline;
                "
              >
                <br />
              </p>
              <p
                style="
                  line-height: 150%;
                  margin-top: 0pt;
                  margin-bottom: 0pt;
                  direction: ltr;
                  unicode-bidi: embed;
                  vertical-align: baseline;
                "
              >
                <span style="font-size: 16px">
                  <strong>我们所擅长的：</strong>
                </span>
              </p>
              <p
                style="
                  line-height: 150%;
                  margin-top: 0pt;
                  margin-bottom: 0pt;
                  direction: ltr;
                  unicode-bidi: embed;
                  vertical-align: baseline;
                "
              >
                <span style="font-size: 16px">
                  <strong>
                    <br />
                  </strong>
                </span>
              </p>
              <p
                style="
                  margin-top: 0pt;
                  margin-bottom: 0pt;
                  direction: ltr;
                  unicode-bidi: embed;
                  vertical-align: baseline;
                "
              >
                •提供管道切割.焊接完整解决方案
              </p>
              <p
                style="
                  margin-top: 0pt;
                  margin-bottom: 0pt;
                  direction: ltr;
                  unicode-bidi: embed;
                  vertical-align: baseline;
                "
              >
                •管焊设备核心技术自主研发
              </p>
              <p
                style="
                  margin-top: 0pt;
                  margin-bottom: 0pt;
                  direction: ltr;
                  unicode-bidi: embed;
                  vertical-align: baseline;
                "
              >
                •采用进口元器件组装性价比高，完美替代进口设备
              </p>
              <p
                style="
                  margin-top: 0pt;
                  margin-bottom: 0pt;
                  direction: ltr;
                  unicode-bidi: embed;
                  vertical-align: baseline;
                "
              >
                •售后服务零担忧，维修免费提供备用机
              </p>
              <br />

              <p style="text-align: left">
                <img
                  title="联系方式"
                  src="../../static/images/6354613687233450007845073.jpg"
                />&nbsp;
              </p>
              <br />
              <p style="text-align: left; text-indent: 2em">
                <span style="color: #255993; font-size: 16px">
                  <strong>
                    <img
                      style="float: right"
                      title="联系"
                      src="../../static/images/6354613696960012505128734.jpg"
                    />上海威遥信息技术有限公司
                  </strong>
                </span>
              </p>
              <p style="text-align: left; text-indent: 2em">
                销售热线：
                <span style="color: #255993">
                  <strong>021-65056515</strong>
                </span>
              </p>
              <p style="text-align: left; text-indent: 2em">
                售后热线：
                <strong
                  style="color: #255993; text-indent: 28px; white-space: normal"
                  >18616336851</strong
                >
              </p>
              <p style="text-align: left; text-indent: 2em">
                公司传真：021-65053165
              </p>
              <p style="text-align: left; text-indent: 2em">
                公司邮箱：18616336851@163.com
              </p>
              <p style="text-align: left; text-indent: 2em">
                公司地址：江苏省昆山市周市镇民管路25号1号楼2楼
              </p>
              <br />
              <br />
            </div>

            <div class="caigou" id="caigou">
              <span class="span_1">
                <span class="red_x">*</span> 表示必填
              </span>
              <strong>采购：{{ list.name }}</strong>
            </div>

            <table class="caigou_tab">
              <tr>
                <td width="120" class="tr">
                  <span class="red_x">*</span> 联系人：
                </td>
                <td width="431">
                  <input
                    type="text"
                    v-model="f_name"
                    placeholder="请输入联系人"
                    size="50"
                    maxlength="30"
                    class="text"
                  />
                </td>
              </tr>

              <tr>
                <td class="tr"><span class="red_x">*</span> 手机号码：</td>
                <td>
                  <input
                    type="text"
                    v-model="f_tel"
                    placeholder="请输入手机号码"
                    size="50"
                    maxlength="11"
                    class="text"
                  />
                </td>
              </tr>
              <tr>
                <td class="tr">电子邮件：</td>
                <td>
                  <input
                    type="text"
                    v-model="f_mail"
                    placeholder="请输入电子邮件"
                    size="50"
                    maxlength="50"
                    class="text"
                  />
                </td>
              </tr>

              <tr>
                <td class="tt"><span class="red_x">*</span> 采购意向描述：</td>
                <td>
                  <textarea
                    v-model="f_info"
                    cols="80"
                    rows="5"
                    placeholder="请输入采购意向"
                    maxlength="300"
                    class="textarea"
                  ></textarea>
                </td>
              </tr>
              <tr>
                <td></td>
                <td>
                  请填写
                  <span class="span_b">采购</span
                  >的产品数量和产品描述，方便我们进行统一备货。
                </td>
              </tr>

              <tr>
                <td></td>
                <td>
                  <div
                    style="
                      cursor: pointer;
                      color: #fff;
                      font-size: 14px;
                      font-weight: bold;
                      height: 24px;
                      line-height: 24px;
                      width: 60px;
                      text-align: center;
                      background: #255990;
                    "
                    @click="toup"
                  >
                    提交
                  </div>
                </td>
              </tr>
            </table>
          </div>
          <!--  <div class="ad3" id="cntrAd_0">
          </div>-->
          <h4 class="t06 f14 mt8">相关资讯</h4>
          <div class="info_b2">
            <ul class="p_list_ul2">
              <li v-for="item in news" :key="item.id">
                <span class="fr">{{ item.create_time }}</span>
                <router-link
                  tag="a"
                  target="_blank"
                  :to="{ name: 'news', params: { id: item.id } }"
                  >{{ item.title }}</router-link
                >
              </li>
            </ul>
            <div class="clear"></div>
          </div>
        </div>
        <div class="rightbot"></div>
      </div>

      <div class="leftr" style="float: right">
        <div class="leib2">
          <div class="tit">
            <span>产品中心</span>
          </div>
          <div class="nr">
            <h4 sid="0001,0005">
              <router-link
                tag="a"
                :to="{ name: 'product', params: { id: 1, nid: 5 } }"
                >按产品类别分</router-link
              >
            </h4>
            <ul>
              <li v-for="item in lista" :key="item.id">
                <router-link
                  tag="a"
                  :to="{ name: 'product', params: { id: item.id } }"
                  >{{ item.mc }}</router-link
                >
              </li>
            </ul>
            <h4 sid="0001,0026">
              <router-link
                tag="a"
                :to="{ name: 'product', params: { id: 1, nid: 5 } }"
                >按应用行业分</router-link
              >
            </h4>
            <ul>
              <li v-for="item in listb" :key="item.id">
                <router-link
                  tag="a"
                  :to="{ name: 'product', params: { id: item.id } }"
                  >{{ item.mc }}</router-link
                >
              </li>
            </ul>
            <h4>
              <a href="#" title="焊接材料">焊接材料</a>
            </h4>
            <ul>
              <li v-for="item in listc" :key="item.id">
                <router-link
                  tag="a"
                  :to="{ name: 'product', params: { id: item.id } }"
                  >{{ item.mc }}</router-link
                >
              </li>
            </ul>
            <h4>
              <a href="#" title="焊接配件">焊接配件</a>
            </h4>
            <ul>
              <li v-for="item in listd" :key="item.id">
                <router-link
                  tag="a"
                  :to="{ name: 'product', params: { id: item.id } }"
                  >{{ item.mc }}</router-link
                >
              </li>
            </ul>
          </div>
        </div>
        <div class="leftbot"></div>

        <div class="leib mt10" id="lefttuijian">
          <div class="tit">推荐产品</div>
          <div class="nr">
            <dl class="pd_t05_con_dl" v-for="item in hotlist" :key="item.id">
              <dt>
                <router-link
                  :to="{ name: 'pinfo', params: { id: item.id, nid: 5 } }"
                >
                  <img :src="item.img" />
                </router-link>
              </dt>
              <dd>
                <router-link
                  :to="{ name: 'pinfo', params: { id: item.id, nid: 5 } }"
                  >{{ item.name }}</router-link
                >
              </dd>
            </dl>

            <div class="clear"></div>
          </div>
        </div>
        <div class="leftbot"></div>
        <div class="leib3 mt10">
          <div class="tit">联系方式</div>
          <div class="nr">
            <div class="dianhua">
              销售热线：
              <br />
              <span>021-65056515</span>
            </div>
            <div class="dianhua">
              售后热线：
              <br />
              <span>18616336851</span>
            </div>
            <p><span>公司电话：</span>021-65056515</p>
            <p><span>公司传真：</span>021-65053165</p>
            <p><span>公司邮箱：</span>18616336851@163.com</p>
            <p>
              <span>公司地址：</span>
              上海市杨浦区军工路100号20栋
            </p>
            <p>
              <span>工厂地址：</span>
              江苏省昆山市周市镇民管路25号1号楼2楼
            </p>
          </div>
          <div class="leftbot"></div>
        </div>
      </div>
      <div class="clear"></div>
    </div>
  </div>
</template>

<script>
import { getProductInfo, postFrom } from "@/utils/api"; //引入api至当前文件
import searchC from "@/views/search";
export default {
  name: "pinfo",
  data() {
    return {
      kimg: "",
      list: "",
      lista: [],
      listb: [],
      listc: [],
      listd: [],
      hotlist: [],
      news: [],
      plist: [],
      f_name: "",
      f_tel: "",
      f_mail: "",
      f_info: "",
    };
  },
  components: {
    searchC,
  },
  mounted() {
    this.intPage();
  },
  watch: {
    $route() {
      this.intPage();
    },
  },
  methods: {
    intPage() {
      let id = this.$route.params.id ? this.$route.params.id : 1;
      getProductInfo(id).then((res) => {
        if (!res.list) {
          this.$router.push({
            name: "home",
            params: { id: 1, nid: 1 },
          });
          return;
        }
        this.kimg = res.imgs;
        this.plist = res.plist;
        this.list = res.list;
        this.hotlist = res.hotlist;
        this.news = res.news;
        this.lista = res.catlist.filter((item) => {
          return item.dlid == 1;
        });
        this.listb = res.catlist.filter((item) => {
          return item.dlid == 3;
        });
        this.listc = res.catlist.filter((item) => {
          return item.dlid == 4;
        });
        this.listd = res.catlist.filter((item) => {
          return item.dlid == 5;
        });
      });
    },
    tofooter() {
      document.querySelector("#caigou").scrollIntoView(true);
    },
    toup() {
      if (!this.f_name.replace(/\s+/g, "")) {
        alert("请输入联系人~");
        return;
      }
      if (!/^[1][3,4,5,7,8][0-9]{9}$/.test(this.f_tel)) {
        alert("请输入正确的手机号码~");
        return;
      }
      if (!this.f_info.replace(/\s+/g, "")) {
        alert("请输入采购意向描述~");
        return;
      }
      let data = {};
      data.f_name = this.f_name;
      data.f_tel = this.f_tel;
      data.f_mail = this.f_mail;
      data.f_info = this.f_info;
      postFrom(data).then((res) => {
        if (res.code == 200) {
          alert("提交成功~");
          this.f_name = "";
          this.f_tel = "";
          this.f_mail = "";
          this.f_info = "";
        }
      });
    },
  },
};
</script>

<style scoped>
</style>
